module.exports = __webpack_public_path__ + "media/images/icons/icon-x-03af5556a54d6dbe405f67c2af2f2f44.svg";